import { render, staticRenderFns } from "./EventStaff.vue?vue&type=template&id=42e93ffd&scoped=true"
import script from "./EventStaff.vue?vue&type=script&lang=ts&setup=true"
export * from "./EventStaff.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./EventStaff.vue?vue&type=style&index=0&id=42e93ffd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e93ffd",
  null
  
)

export default component.exports